"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateGetEg = void 0;
const adabyron_client_datos_cliente_get_eg_1 = require("@gcloud-npm/adabyron.client.datos-cliente.get-eg");
const mergeIp3gHashes = (newHashes, lastHashes) => {
    const result = Object.assign({}, lastHashes);
    const keys = Object.keys(newHashes);
    keys.forEach((keyName) => {
        if (newHashes[keyName]) {
            result[keyName] = newHashes[keyName];
        }
    });
    return result;
};
const composeI3Object = (ip3gResponse) => {
    const i3DssObj = ip3gResponse || {};
    const { z, c, l, p, a, x, t, g } = i3DssObj;
    return {
        userCUCFijoHash: c || "",
        userCUCMovilHash: l || "",
        userCUCPrepagoHash: p || "",
        userIdPartyHash: z || "",
        x: x || "",
        t: t || "",
        g: g || "",
        a: a || "",
    };
};
const tranformXcol2Ip3Hashes = (xcol = "") => {
    try {
        const decodedXcol = JSON.parse(window.atob(xcol.split(".")[1]));
        return composeI3Object(decodedXcol);
    }
    catch (error) {
        return composeI3Object({});
    }
};
const handleXCOLCookie = (name) => {
    try {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        return parts.length === 2 ? parts.pop().split(";").shift() : "";
    }
    catch (e) {
        return "";
    }
};
const setSessionValue = (data) => {
    try {
        if (data && data.XCOL) {
            sessionStorage.setItem("IC_XCOL_ENCODED", data.XCOL);
            const myToken = data.XCOL.split(".")[1];
            if (myToken) {
                sessionStorage.setItem("IC_XCOL_1", window.atob(myToken));
                sessionStorage.setItem("IC_XCOL_TS_1", new Date().getTime());
            }
        }
    }
    catch (e) {
        console.error(e);
    }
};
const updateGetEg = ({ context }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield (0, adabyron_client_datos_cliente_get_eg_1.getEg)({
            data: {
                xcol: handleXCOLCookie("XCOL") || "",
            },
            // Allways invoke as not logged to avoid softlogged unauthorized errors
            context: Object.assign(Object.assign({}, context), { userType: "" })
        });
        setSessionValue(response);
    }
    catch (e) {
        console.error(`Error updating getEg: ${e}`);
    }
});
exports.updateGetEg = updateGetEg;
const hasEgKeys = (egObject) => {
    let res = false;
    const possibleValues = [
        "userCUCFijoHash",
        "userCUCMovilHash",
        "userCUCPrepagoHash",
        "userIdPartyHash",
        "a",
        "x",
        "t",
        "g",
    ];
    const findElement = Object.keys(egObject).find((key) => possibleValues.includes(key));
    if (findElement) {
        res = true;
    }
    return res;
};
const isMoreThan24Hours = (tsUserRecom) => {
    let res = true;
    if (tsUserRecom) {
        const tsNow = Date.now();
        const msDay = 1000 * 60 * 60 * 24;
        const diferenciaEnMilisegundos = tsUserRecom !== -1 ? tsNow - tsUserRecom : msDay;
        const diferenciaEnHoras = diferenciaEnMilisegundos / (1000 * 60 * 60);
        res = diferenciaEnHoras >= 24;
    }
    return res;
};
const getEg = ({ persistedInfo, context }) => __awaiter(void 0, void 0, void 0, function* () {
    const { tsUserRecom } = persistedInfo;
    const moreThan24Hours = isMoreThan24Hours(tsUserRecom);
    let userIdPartyHashFromGetEg = '';
    // 1) Extraemos info getEg para enviar a GA
    if (persistedInfo && hasEgKeys(persistedInfo) && !moreThan24Hours) {
        // 1.1) SI tenemos ya la info en ts o no han pasado 24 horas
        //  como no guardamos en redux ni hace falta sobreescribir ts con la misma info, no hace falta nada
    }
    else {
        // 1.2) NO tenemos info en ts o han pasado 24H
        yield (0, exports.updateGetEg)({ context });
        const getetghashes = tranformXcol2Ip3Hashes(sessionStorage.getItem("IC_XCOL_ENCODED"));
        Promise.resolve().then(() => __importStar(require("@gcloud-npm/utils.secure.local-storage"))).then((module) => {
            let secureStorage = module.default;
            secureStorage = new secureStorage();
            const persiRest = mergeIp3gHashes(getetghashes, secureStorage.getItem("ts"));
            if (persiRest && persiRest.userIdPartyHash) {
                userIdPartyHashFromGetEg = persiRest.userIdPartyHash;
            }
            if (persiRest && persiRest.userIdPartyHash && !persiRest.userType && !persiRest.userName) {
                delete persiRest.userIdPartyHash;
            }
            secureStorage.setItem("ts", Object.assign(Object.assign({}, persiRest), { userIdPartyHashFromGetEg, tsUserRecom: Date.now() }));
        });
    }
});
exports.default = getEg;
//# sourceMappingURL=index.js.map